export default __webpack_public_path__ + "static/media/patanjali.74ae4630.jpg";